const GET_GROUP_LIST_REQUEST = "GET_GROUP_LIST_REQUEST";
const GET_GROUP_LIST_COMPLETED = "GET_GROUP_LIST_COMPLETED";
const GET_GROUP_LIST_ERROR = "GET_GROUP_LIST_ERROR";

const GET_GROUP_CARD_REQUEST = "GET_GROUP_CARD_REQUEST";
const GET_GROUP_CARD_COMPLETED = "GET_GROUP_CARD_COMPLETED";
const GET_GROUP_CARD_ERROR = "GET_GROUP_CARD_ERROR";

const GET_PLAN_LIST_REQUEST = "GET_PLAN_LIST_REQUEST";
const GET_PLAN_LIST_COMPLETED = "GET_PLAN_LIST_COMPLETED";
const GET_PLAN_LIST_ERROR = "GET_PLAN_LIST_ERROR";

const GET_ORG_TEACHER_LIST_REQUEST = "GET_ORG_TEACHER_LIST_REQUEST";
const GET_ORG_TEACHER_LIST_COMPLETED = "GET_ORG_TEACHER_LIST_COMPLETED";
const GET_ORG_TEACHER_LIST_ERROR = "GET_ORG_TEACHER_LIST_ERROR";

const GET_GROUP_SYSTEM_INFO_REQUEST = "GET_GROUP_SYSTEM_INFO_REQUEST";
const GET_GROUP_SYSTEM_INFO_COMPLETED = "GET_GROUP_SYSTEM_INFO_COMPLETED";
const GET_GROUP_SYSTEM_INFO_ERROR = "GET_GROUP_SYSTEM_INFO_ERROR";

const GET_GROUP_MAIN_REQUEST = "GET_GROUP_MAIN_REQUEST";
const GET_GROUP_MAIN_COMPLETED = "GET_GROUP_MAIN_COMPLETED";
const GET_GROUP_MAIN_ERROR = "GET_GROUP_MAIN_ERROR";

const GET_GROUP_STUDENTS_REQUEST = "GET_GROUP_STUDENTS_REQUEST";
const GET_GROUP_STUDENTS_COMPLETED = "GET_GROUP_STUDENTS_COMPLETED";
const GET_GROUP_STUDENTS_ERROR = "GET_GROUP_STUDENTS_ERROR";

const GET_GROUP_PLAN_REQUEST = "GET_GROUP_PLAN_REQUEST";
const GET_GROUP_PLAN_COMPLETED = "GET_GROUP_PLAN_COMPLETED";
const GET_GROUP_PLAN_ERROR = "GET_GROUP_PLAN_ERROR";

const GET_GROUP_PROGRAM_INFO_REQUEST = "GET_GROUP_PROGRAM_INFO_REQUEST";
const GET_GROUP_PROGRAM_INFO_COMPLETED = "GET_GROUP_PROGRAM_INFO_COMPLETED";
const GET_GROUP_PROGRAM_INFO_ERROR = "GET_GROUP_PROGRAM_INFO_ERROR";

const UPDATE_GROUP_MAIN_REQUEST = "UPDATE_GROUP_MAIN_REQUEST";
const UPDATE_GROUP_MAIN_COMPLETED = "UPDATE_GROUP_MAIN_COMPLETED";
const UPDATE_GROUP_MAIN_ERROR = "UPDATE_GROUP_MAIN_ERROR";

const DELETE_GROUP_REQUEST = "DELETE_GROUP_REQUEST";
const DELETE_GROUP_COMPLETED = "DELETE_GROUP_COMPLETED";
const DELETE_GROUP_ERROR = "DELETE_GROUP_ERROR";

const CREATE_GROUP_REQUEST = "CREATE_GROUP_REQUEST";
const CREATE_GROUP_COMPLETED = "CREATE_GROUP_COMPLETED";
const CREATE_GROUP_ERROR = "CREATE_GROUP_ERROR";

const CREATE_NEW_STUDENT_REQUEST = "CREATE_NEW_STUDENT_REQUEST";
const CREATE_NEW_STUDENT_COMPLETED = "CREATE_NEW_STUDENT_COMPLETED";
const CREATE_NEW_STUDENT_ERROR = "CREATE_NEW_STUDENT_ERROR";

const ADD_EXIST_STUDENT_REQUEST = "ADD_EXIST_STUDENT_REQUEST";
const ADD_EXIST_STUDENT_COMPLETED = "ADD_EXIST_STUDENT_COMPLETED";
const ADD_EXIST_STUDENT_ERROR = "ADD_EXIST_STUDENT_ERROR";

const DELETE_STUDENT_REQUEST = "DELETE_STUDENT_REQUEST";
const DELETE_STUDENT_COMPLETED = "DELETE_STUDENT_COMPLETED";
const DELETE_STUDENT_ERROR = "DELETE_STUDENT_ERROR";

const MOVE_STUDENT_REQUEST = "MOVE_STUDENT_REQUEST";
const MOVE_STUDENT_COMPLETED = "MOVE_STUDENT_COMPLETED";
const MOVE_STUDENT_ERROR = "MOVE_STUDENT_ERROR";

const UPLOAD_IMPORT_FILE_REQUEST = "UPLOAD_IMPORT_FILE_REQUEST";
const UPLOAD_IMPORT_FILE_COMPLETED = "UPLOAD_IMPORT_FILE_COMPLETED";
const UPLOAD_IMPORT_FILE_ERROR = "UPLOAD_IMPORT_FILE_ERROR";

const CHECK_IMPORT_FILE_REQUEST = "CHECK_IMPORT_FILE_REQUEST";
const CHECK_IMPORT_FILE_COMPLETED = "CHECK_IMPORT_FILE_COMPLETED";
const CHECK_IMPORT_FILE_ERROR = "CHECK_IMPORT_FILE_ERROR";

const EXEC_IMPORT_FILE_REQUEST = "EXEC_IMPORT_FILE_REQUEST";
const EXEC_IMPORT_FILE_COMPLETED = "EXEC_IMPORT_FILE_COMPLETED";
const EXEC_IMPORT_FILE_ERROR = "EXEC_IMPORT_FILE_ERROR";

const GET_REQUEST_GROUP_REQUEST = "GET_REQUEST_GROUP_REQUEST";
const GET_REQUEST_GROUP_COMPLETED = "GET_REQUEST_GROUP_COMPLETED";
const GET_REQUEST_GROUP_ERROR = "GET_REQUEST_GROUP_ERROR";

const CHANGE_STATE_GROUP_REQUEST = "CHANGE_STATE_GROUP_REQUEST";
const CHANGE_STATE_GROUP_COMPLETED = "CHANGE_STATE_GROUP_COMPLETED";
const CHANGE_STATE_GROUP_ERROR = "CHANGE_STATE_GROUP_ERROR";

export default {
  GET_GROUP_LIST_REQUEST,
  GET_GROUP_LIST_COMPLETED,
  GET_GROUP_LIST_ERROR,

  GET_GROUP_CARD_REQUEST,
  GET_GROUP_CARD_COMPLETED,
  GET_GROUP_CARD_ERROR,

  GET_GROUP_SYSTEM_INFO_REQUEST,
  GET_GROUP_SYSTEM_INFO_COMPLETED,
  GET_GROUP_SYSTEM_INFO_ERROR,

  GET_GROUP_MAIN_REQUEST,
  GET_GROUP_MAIN_COMPLETED,
  GET_GROUP_MAIN_ERROR,

  GET_GROUP_STUDENTS_REQUEST,
  GET_GROUP_STUDENTS_COMPLETED,
  GET_GROUP_STUDENTS_ERROR,

  GET_GROUP_PLAN_REQUEST,
  GET_GROUP_PLAN_COMPLETED,
  GET_GROUP_PLAN_ERROR,

  UPDATE_GROUP_MAIN_REQUEST,
  UPDATE_GROUP_MAIN_COMPLETED,
  UPDATE_GROUP_MAIN_ERROR,

  DELETE_GROUP_REQUEST,
  DELETE_GROUP_COMPLETED,
  DELETE_GROUP_ERROR,

  CREATE_GROUP_REQUEST,
  CREATE_GROUP_COMPLETED,
  CREATE_GROUP_ERROR,

  MOVE_STUDENT_REQUEST,
  MOVE_STUDENT_COMPLETED,
  MOVE_STUDENT_ERROR,

  GET_PLAN_LIST_REQUEST,
  GET_PLAN_LIST_COMPLETED,
  GET_PLAN_LIST_ERROR,

  GET_ORG_TEACHER_LIST_REQUEST,
  GET_ORG_TEACHER_LIST_COMPLETED,
  GET_ORG_TEACHER_LIST_ERROR,

  GET_GROUP_PROGRAM_INFO_REQUEST,
  GET_GROUP_PROGRAM_INFO_COMPLETED,
  GET_GROUP_PROGRAM_INFO_ERROR,

  CREATE_NEW_STUDENT_REQUEST,
  CREATE_NEW_STUDENT_COMPLETED,
  CREATE_NEW_STUDENT_ERROR,

  ADD_EXIST_STUDENT_REQUEST,
  ADD_EXIST_STUDENT_COMPLETED,
  ADD_EXIST_STUDENT_ERROR,

  DELETE_STUDENT_REQUEST,
  DELETE_STUDENT_COMPLETED,
  DELETE_STUDENT_ERROR,

  UPLOAD_IMPORT_FILE_REQUEST,
  UPLOAD_IMPORT_FILE_COMPLETED,
  UPLOAD_IMPORT_FILE_ERROR,

  CHECK_IMPORT_FILE_REQUEST,
  CHECK_IMPORT_FILE_COMPLETED,
  CHECK_IMPORT_FILE_ERROR,

  EXEC_IMPORT_FILE_REQUEST,
  EXEC_IMPORT_FILE_COMPLETED,
  EXEC_IMPORT_FILE_ERROR,

  GET_REQUEST_GROUP_REQUEST,
  GET_REQUEST_GROUP_COMPLETED,
  GET_REQUEST_GROUP_ERROR,

  CHANGE_STATE_GROUP_REQUEST,
  CHANGE_STATE_GROUP_COMPLETED,
  CHANGE_STATE_GROUP_ERROR
};
